module.exports = __webpack_public_path__ + "static/media/img_6.bb861c36.png";